import React from "react";
import GeneralSection from "../../newComponents/generalSection";

const horizontalRule = ({ block, }) => {

  let horizontalRuleElement;

  switch (block.horizontalRuleType) {
    case "standard":
      horizontalRuleElement = <div className="my-4" style={{borderBottom: "1px solid #e6e6e6", clear: "both"}}/>;
      break;
    case "invisible":
      horizontalRuleElement = <div style={{clear: "both"}}/>;
      break;
    default:
      horizontalRuleElement = <div className="my-4" style={{borderBottom: "1px solid #e6e6e6", clear: "both"}}/>;
      break;
  }

  return (
    <GeneralSection>{horizontalRuleElement}</GeneralSection>
  );
}

export default horizontalRule;